import { render, staticRenderFns } from "./beta-system-info.vue?vue&type=template&id=3c0c7342&scoped=true"
import script from "./beta-system-info.vue?vue&type=script&lang=js"
export * from "./beta-system-info.vue?vue&type=script&lang=js"
import style0 from "./beta-system-info.vue?vue&type=style&index=0&id=3c0c7342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c7342",
  null
  
)

export default component.exports